<template>
    <div class="card p-2">
        {{ address.address }}
        <div v-if="address.is_airport && address.flight_number">
            ({{ $t('orders.flight') }} #{{ address.flight_number }})
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            address: {
                type: Object,
                required: true,
            },
        },
    };
</script>
